import { data } from '../../svg/Action/data';
import { makeIcon } from '../makeIcon';

export const Action = makeIcon(data, 'action', 'Action');

export default Action;
